'use client';

import React, { useEffect } from 'react';
import './modal.css'; // We'll create this next

// interface ModalProps {
//   isOpen: boolean;
//   onClose?: () => void;
//   children: React.ReactNode;
//   width?: string;
//   height?: string;
//   allowClose?: boolean; // false = completely non-dismissible
// }

const Modal= ({
  isOpen,
  onClose,
  children,
  width = '500px',
  height = 'auto',
  allowClose = false,
}) => {
  // Handle Escape key only if allowed
  useEffect(() => {
    // const handleEsc = () => {
    //   if (allowClose && e.key === 'Escape' && onClose) {
    //     onClose();
    //   }
    // };

    if (isOpen) {
      // document.addEventListener('keydown', handleEsc);xxs
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    }

    return () => {
      // document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, allowClose, onClose]);
  const handleAccept = ()=>{
    onClose && onClose()
  }
  // Prevent closing when clicking backdrop if not allowed
  const handleBackdropClick = () => {
    if (allowClose && e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div
        className="modal-content"
        style={{ width, height }}
        onClick={(e) => e.stopPropagation()} // Prevent click from bubbling to overlay
      >
        {/* Close button - only shown if allowClose is true */}
        {allowClose && onClose && (
          <button className="modal-close-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        )}

        <div className="modal-body">
          {children}
          {onClose && (
            <div className="consent-actions">
      
              <button onClick={handleAccept} className="btn-accept">
                Accept
              </button>
            </div>

          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;